import { createContext, useContext } from 'react';

import { Locale, ShopBundle } from '@types-internal';

type AppContextData = {
  shopBundle: ShopBundle;
  domain: string;
  locale: Locale;
  csrfToken?: string;
  sid?: string;
};

// Provided default values are only there for typescript to be happy.
// They will never be used.
const AppContext = createContext<AppContextData>({
  shopBundle: 'zooplus',
  domain: 'zooplus.com',
  locale: 'zu',
  sid: undefined,
  csrfToken: undefined,
});

export const useAppContext = () => useContext(AppContext);

export default AppContext.Provider;
